<template>
    <div class="panel-voices-list">
        <base-scroll
            hasBorder
            height="370px"
        >
            <template v-slot:content>
                <ul class="panel-voices-list__configured-voices">
                    <li
                        v-for="voice in get_panelConfiguredVoices"
                        :key="voice.id"
                    >
                        <voice-badge
                            :id="voice.id"
                            :name="voice.name"
                            :favourite-always-visible="voice.subscriberOnly"
                            :has-favourite="voice.subscriberOnly"
                            :icon="voiceIcon(voice.voiceId)"
                            urlBackground
                            @userClick="selectVoice(voice.id, voice.subscriberOnly)"
                        >
                            <template #icon>
                                <base-icon
                                    name="twitch-prime"
                                    size="normal"
                                    color="active"
                                >
                                </base-icon>
                            </template>

                            <template #subtitle>
                                <base-icon
                                    name="bits"
                                    size="xsmall"
                                    color="light"
                                >
                                </base-icon>

                                <div>
                                    {{ voice.price > 0 ? `${voice.price} bits` : $t('twitch.globalMsg.free') }}
                                </div>
                            </template>
                        </voice-badge>
                    </li>
                </ul>
            </template>
        </base-scroll>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'PanelVoicesList',

    components: {
        VoiceBadge: () => import(/* webpackChunkName: "VoiceBadge" */ '@RepoComponent/VoiceBadge/VoiceBadge'),
        BaseIcon: () => import(/* webpackChunkName: "BaseIcon" */ '@RepoComponent/BaseIcon/BaseIcon'),
        BaseScroll: () => import(/* webpackChunkName: "BaseScroll" */ '@RepoComponent/BaseScroll/BaseScroll' ),
    },

    computed: {
        ...mapGetters({
            get_voiceIcon: 'panel/get_voiceIcon',
            get_panelConfiguredVoices: 'panel/get_panelConfiguredVoices',
        }),

        ...mapState({
            globalStore: state => state.global,
        }),

        viewerIsLinked() {
            return this.globalStore.viewerIsLinked;
        },
    },

    methods: {
        selectVoice(id, subscriberOnly) {
            if (subscriberOnly && !this.viewerIsLinked) {
                this.requestToShareId();
                return;
            }

            if (subscriberOnly && this.viewerIsLinked) {
                this.goToVoiceSelected(id);
            }

            if (!subscriberOnly) {
                this.goToVoiceSelected(id);
            }

        },

        goToVoiceSelected(id) {
            this.$router.push({ name: 'VoiceSelected', params: { id } });
        },

        requestToShareId() {
            this.$twitch.actions.requestIdShare();
        },

        voiceIcon(voiceId) {
            return this.get_voiceIcon(voiceId);
        },
    },
};
</script>

<style src="./PanelVoicesList.scss" lang="scss" scoped></style>
